
/**
 * 특정 사용자의 트윗을 조회할 때 사용하는 사용자 ID (type이 OTHER일 경우 필수)
 */
export type UserIdParamParameter = number;
